import { WarehouseItemWorkRequestKind } from "@redotech/crdb-enums/fulfillment/warehouse-item-work-request-kind";
import { ItemPhotoRequestBlockedReason } from "@redotech/redo-fulfillment-common/item-photo-request-blocked";
import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import {
  photoInstructionsIdFormat,
  warehouseItemWorkRequestIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

/**
 * Queues warehouse work against one unit. Automated callers (a processing flow
 * step) cannot act on a refusal, so an item that cannot be photographed comes
 * back as `skipped` with a reason rather than as an error.
 */
export const createItemWorkRequest = {
  name: "createItemWorkRequest" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    kind: z.enum(WarehouseItemWorkRequestKind),
    photoInstructionsId: photoInstructionsIdFormat.schema,
  }),
  output: z.discriminatedUnion("outcome", [
    z.object({
      outcome: z.literal("created"),
      requestId: warehouseItemWorkRequestIdFormat.schema,
    }),
    z.object({
      outcome: z.literal("skipped"),
      reason: z.enum(ItemPhotoRequestBlockedReason),
    }),
  ]),
};
